<template>
  <div class="w-100 my-5">
    <div class="my-5">
      <span class="font-15 font-bold">PromoCode List: {{ promoList.length }}</span>
    </div>
    <div class="my-5" v-if="(promoList.length > 0)">
      <v-card class="my-2 box-white d-flex flex-column" v-for="(item, index) in promoList" :key="(item, index)">
        <div class="m-2 row">
          <span class="col-sm">{{ item.promoId }}</span>
          <span class="col-sm">{{ item.code }}</span>
          <span class="col-sm">{{ `${item.percent}%` }}</span>
          <span class="col-sm">{{ `${item.totalQuantity} / ${item.usedQuantity}` }}</span>
          <span class="col-sm">{{ getDateStringFromTimestamp(item.createdAt) }}</span>
        </div>
      </v-card>
    </div>
    <div class="py-40 center" v-else>
      <span class="font-20 alpha-07">{{ $t('no_data_found') }}</span>
    </div>
  </div>
</template>

<script>
import { firestore } from '../../../main';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { getDateStringFromTimestamp, showLoading } from '../../../functions';

export default {
  name: 'AttackLink',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    }
  },
  data() {
    return {
      promoList: [],
    }
  },
  mounted() {
    if (window.location.hostname !== 'localhost') {
      this.$router.push('/');
    } else {
      this.getPromoListTask();
    }
  },
  methods: {
    getDateStringFromTimestamp,
    getPromoListTask() {
      const loader = showLoading(this, 1);
      const q = query(collection(firestore, 'promoCode'), where('eventId', '==', this.$route.params.eventId));
      getDocs(q).then(querySnapshot => {
        loader.hide();
        const list = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          list.push(data);
        });
        this.promoList = list;
      }).catch(error => {
        loader.hide();
        this.$toast.error('Unexpected error occurs - ' + error.message);
      });
    }
  }
};
</script>